export default {
  namespaced: true,
  state: {
    colors: ["#FBD308", "#349A6B", "#3F84E5", "#FF4560",
      "#775DD0", "#FEB019", "#9CE2BE", "#008FFB"],
    lifeCycleStages: [
      { order: 1, value: 'material', label: '원료 획득' },
      { order: 2, value: 'upstream', label: '업스트림 운송' },
      { order: 3, value: 'production', label: '생산' },
      { order: 4, value: 'downstream', label: '다운스트림 운송' },
      { order: 5, value: 'use', label: '사용' },
      { order: 6, value: 'disposal', label: '폐기' },
    ],
    categories: [
      { category: 1, title: '구매한 제품 및 서비스', type: 'up' },
      { category: 2, title: '자본재(투자 및 구매)', type: 'up' },
      { category: 3, title: 'Scope 1, 2가 아닌 에너지 활동', type: 'up' },
      { category: 4, title: '업스트림 운송', type: 'up' },
      { category: 5, title: '공정 배출 폐기물', type: 'up' },
      { category: 6, title: '임직원 출장', type: 'up' },
      { category: 7, title: '임직원 출퇴근', type: 'up' },
      { category: 8, title: '업스트림 임차자산', type: 'down' },
      { category: 9, title: '다운스트림 수송', type: 'down' },
      { category: 10, title: '판매제품의 가공', type: 'down' },
      { category: 11, title: '판매제품 사용', type: 'down' },
      { category: 12, title: '판매제품 폐기', type: 'down' },
      { category: 13, title: '다운스트림 임대', type: 'down' },
      { category: 14, title: '프랜차이즈', type: 'down' },
      { category: 15, title: '투자', type: 'down' }
    ],
  },
  getters: {
    colors(state) {
      return state.colors;
    },
    categories(state) {
      return state.categories;
    },
    lifeCycleStages(state) {
      return state.lifeCycleStages;
    },
  },
};
